import { useState } from "react";
import { Icon } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { ChangePasswordPayload } from "modules/AccountSettings/components/ChangePasswordModal/hooks";
import type { Path } from "react-hook-form";

type PasswordFieldProps = {
  name: Path<ChangePasswordPayload>;
  placeholder: string;
  onChange: (password: string) => void;
};

const FormHelper = createFormHelper<ChangePasswordPayload>();

export const PasswordField = ({ name, placeholder, onChange }: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <FormHelper.Field.Input name={name} inputProps={{ placeholder, type: showPassword ? "text" : "password" }} onChange={value => onChange(value)} />
      <Icon
        className={showPassword ? "eye grey password-icon" : "eye slash grey password-icon"}
        onMouseDown={() => setShowPassword(true)}
        onMouseUp={() => setShowPassword(false)}
      />
    </>
  );
};
